// extracted by mini-css-extract-plugin
module.exports = {"component":"MetricInfo_component__r8wJ2","title":"MetricInfo_title__3WWjo","content":"MetricInfo_content__1mtzK"};